var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',[(this.heading)?_c('v-subheader',[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._l((_vm.sorted),function(item){return _c('PersonItem',{key:item.id,attrs:{"value":item,"clickable":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }